import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "convertValue", "onChange"],
  _excluded2 = ["error"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var RadioButton = function RadioButton(props) {
  var givenClassName = props.className,
    _props$convertValue = props.convertValue,
    convertValue = _props$convertValue === void 0 ? function (value) {
      return value;
    } : _props$convertValue,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    radioProps = _objectWithoutProperties(props, _excluded);
  var className = classnames("radio-button", givenClassName);
  var handleChange = useCallback(function (event) {
    onChange({
      target: {
        name: event.target.name,
        value: convertValue(event.target.value)
      }
    });
  }, [onChange, convertValue]);
  return /*#__PURE__*/_jsxs("span", {
    className: className,
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, radioProps), {}, {
      className: "radio-button__input",
      type: "radio",
      onChange: handleChange
    })), /*#__PURE__*/_jsx("span", {
      className: "radio-button__styled-input"
    })]
  });
};
RadioButton.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func
};
export var Checkbox = function Checkbox(props) {
  var error = props.error,
    checkboxProps = _objectWithoutProperties(props, _excluded2);
  var className = classnames("checkbox", props.className, {
    "checkbox--error": error
  });
  var styledInputClassName = classnames("checkbox__styled-input", {
    "checkbox__styled-input--error": error
  });
  var checked = "checked" in props ? props.checked : props.value;
  return /*#__PURE__*/_jsxs("span", {
    className: className,
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, checkboxProps), {}, {
      className: "checkbox__input",
      type: "checkbox",
      checked: checked
    })), /*#__PURE__*/_jsx("span", {
      className: styledInputClassName
    })]
  });
};
Checkbox.propTypes = {
  className: PropTypes.string,
  error: PropTypes.any,
  value: PropTypes.any,
  checked: PropTypes.bool
};